import React from "react";

export default ({ color, size }) => (
  <svg width={size || 24} height={size || 24} viewBox="0 0 24 24">
    <path fill={color} d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
  </svg>
);
